<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <Tab />
      <div class="page-actions">
        <div class="select">
          <div class="item">
            <div class="ipt">
              <el-select
                v-model="tenantId"
                placeholder="商户ID"
                size="mini"
                clearable
              >
                <el-option
                  v-for="item in tabList"
                  :key="item.id"
                  :label="item.tenantName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">用户UID</div> -->
            <div class="ipt">
              <el-input
                placeholder="任务名称"
                clearable
                v-model="name"
                class="userUid_ipt"
                size="mini"
              >
                <!-- <img :src="userUid" alt="" slot="prefix" class="userUid" /> -->
              </el-input>
            </div>
          </div>

          <div class="item">
            <!-- <div class="txt">仓位模式</div> -->
            <div class="ipt">
              <el-select
                size="mini"
                :rules="[
                  { required: true, message: '请选择', trigger: 'change' },
                ]"
                v-model="taskBelongTo"
                placeholder="任务所属"
              >
                <!-- <el-option label="全部仓位模式" value=""> </el-option> -->
                <el-option
                  v-for="(item, index) in taskTypeListOptions"
                  :key="index"
                  :label="item.activityModuleDesc"
                  :value="item.activityModule"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">买卖方向</div> -->
            <div class="ipt">
              <el-select
                size="mini"
                :rules="[
                  { required: true, message: '请选择', trigger: 'change' },
                ]"
                v-model="status"
                placeholder="状态"
              >
                <!-- <el-option label="全部仓位方向" value=""> </el-option> -->
                <el-option
                  v-for="item in statusOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="item">
            <!-- <div class="txt">订单平仓日期</div> -->
            <div class="ipt">
              <el-date-picker
                size="mini"
                v-model="value1"
                type="daterange"
                align="right"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                unlink-panels
                clearable
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </div>
          </div>
          <!-- <div class="item">
            <el-button size="mini" @click="searchYesterday">昨日</el-button>
          </div>
          <div class="item">
            <el-button size="mini" @click="searchToday">今日</el-button>
          </div> -->

          <!-- <div class="item">
            <Add @refresh="refreshList" :tabList="tabList"></Add>
          </div> -->
          <div class="item">
            <el-button size="mini" type="primary" @click="handleSearch"
              >查询</el-button
            >
          </div>
          <div class="item">
            <el-button size="mini" type="primary" @click="handleClearSearch"
              >重置</el-button
            >
          </div>
          <!-- <div class="item">
            <a @click="getExcel" target="_blank">导出Excel</a>
          </div> -->
        </div>
      </div>

      <user-list @refresh="refreshList"></user-list>
      <Del />
    </el-card>
    <!-- 添加用户信息弹框 -->
  </div>
</template>

<script>
import './store'
import UserList from './components/list'
import Tab from '../components/Tab'
import Add from './components/add'
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import moment from 'moment'
import userUid from '@/assets/input/userUid.png'
import invite from '@/assets/input/invite.png'
import channel from '@/assets/input/channel.png'
import api from '../api'

import Del from './components/del'
export default {
  name: 'Management',
  components: {
    UserList,
    Tab,
    Del,
    Add,
  },
  data() {
    return {
      invite,
      channel,
      userUid,
      value1: '',
      status: '',
      taskBelongTo: '',
      name: '',
      tenantId: '',
      tabList: [],
      statusOption: [
        {
          value: 0,
          label: '未激活',
        },
        { value: 1, label: '激活' },
        {
          value: 2,
          label: '结算中',
        },
        { value: 3, label: '过期' },
      ],
      // value1: [
      //   moment(new Date().getTime() - 7 * 1000 * 24 * 60 * 60).format(
      //     "YYYY-MM-DD"
      //   ),
      //   new Date().getFullYear() +
      //     "-" +
      //     (new Date().getMonth() + 1) +
      //     "-" +
      //     new Date().getDate(),
      // ],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
    }
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapState('topPartner', ['topPartner']),
    ...mapState('management', [
      'totalRealizedProfit',
      'totalFee',
      'pagination',
      'symbolList',
      'orderBy',
    ]),
    ...mapGetters('management', [
      'taskTypeListOptions',
      'taskTypeMap',
      'logicOpListArr',
    ]),
  },
  methods: {
    ...mapActions('management', [
      'getHistory',
      'exportExcel',
      'getSymbolList',
      'getTaskType',
      'getLogicOp',
      'getMathOp',
      'getLotteryList',
      'getUserTypeList',
    ]),

    ...mapMutations('management', ['setOrderBy', 'setDelVisible']),

    refreshList(data = {}) {
      this.tenantId = data.tenantId
      this.getHistory({
        name: this.name,
        taskBelongTo: this.taskBelongTo,
        status: this.status,
        tenantId: this.tenantId,
        startTime: this.value1
          ? moment(this.value1[0]).startOf('day').valueOf()
          : '',
        endTime: this.value1
          ? moment(this.value1[1]).endOf('day').valueOf()
          : '',
        ...this.pagination,
        ...data,
      })
    },
    getExcel() {
      this.exportExcel({
        name: this.name,
        taskBelongTo: this.taskBelongTo,
        status: this.status,
        tenantId: -1,
        startTime: this.value1
          ? moment(this.value1[0]).startOf('day').valueOf()
          : '',
        endTime: this.value1
          ? moment(this.value1[1]).endOf('day').valueOf()
          : '',
        ...this.pagination,
      }).then((res) => {
        const link = document.createElement('a')
        const blob = new Blob([res], { type: 'application/vnd.ms-excel' }) //设置文件流
        link.style.display = 'none'
        // 设置连接
        link.href = URL.createObjectURL(blob) //将文件流转化为blob地址
        console.log('link-href', link.href)
        link.download = '历史仓位记录'
        document.body.appendChild(link)
        // 模拟点击事件
        link.click() //设置点击事件
      })
    },

    searchYesterday() {
      this.value1 = [
        moment(new Date().getTime() - 1 * 1000 * 24 * 60 * 60).format(
          'YYYY-MM-DD'
        ),
        moment(new Date().getTime() - 1 * 1000 * 24 * 60 * 60).format(
          'YYYY-MM-DD'
        ),
      ]
      this.handleSearch()
    },
    searchToday() {
      this.value1 = [
        new Date().getFullYear() +
          '-' +
          (new Date().getMonth() + 1) +
          '-' +
          new Date().getDate(),
        new Date().getFullYear() +
          '-' +
          (new Date().getMonth() + 1) +
          '-' +
          new Date().getDate(),
      ]
      this.handleSearch()
    },
    handleSearch() {
      if (!this.tenantId) {
        this.$message.warning('请输入商户ID进行查询')
        return
      }
      this.getHistory({
        tenantId: this.tenantId,
        status: this.status,
        taskBelongTo: this.taskBelongTo,
        name: this.name,
        startTime: this.value1
          ? moment(this.value1[0]).startOf('day').valueOf()
          : '',
        endTime: this.value1
          ? moment(this.value1[1]).endOf('day').valueOf()
          : '',
        ...this.pagination,
        page: 1,
      })
    },

    handleClearSearch() {
      this.status = ''
      this.taskBelongTo = ''
      this.name = ''
      this.value1 = ''
      this.tenantId = ''
      this.handleSearch()
    },
  },
  created() {
    this.$message.warning('请输入商户ID进行查询')
    api.getTenantList().then((res) => {
      if (res.code == 0) {
        const { data } = res
        this.tabList = data
      }
    })
    // this.getSymbolList()
    this.getTaskType()
    this.getLogicOp()
    this.getMathOp()

    // this.getHistory({

    //   status: this.status,
    //   taskBelongTo: this.taskBelongTo,
    //   name: this.name,
    //   startTime: this.value1
    //     ? moment(this.value1[0]).startOf('day').valueOf()
    //     : '',
    //   endTime: this.value1 ? moment(this.value1[1]).endOf('day').valueOf() : '',
    //   ...this.pagination,
    // })
  },
  beforeDestroy() {
    this.setOrderBy(null)
  },
}
</script>

<style lang="less" src="../../../styles/button.less" scoped></style>
